import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

const NOTICIAS = [
  {
    id: 'aeago-novamed-dia-do-engenheiro-agronomo-2026',
    titulo: 'Dia do Engenheiro Agrônomo: AEAGO e Novamed anunciam parceria em saúde para associados',
    subtitulo:
      'AEAGO e Novamed Planos de Saúde se unem para oferecer um benefício especial de saúde aos associados, em celebração ao Dia do Engenheiro Agrônomo.',
    categoria: 'Institucional',
    data: '12 de outubro de 2026',
    imagem: '/imagem/noticias/noticia-novamed.jpeg',
    corpo: [
      '🎁🌱 No Dia do Engenheiro Agrônomo, a AEAGO tem um presente para você!',
      'Para celebrar essa data, a AEAGO e a Novamed Planos de Saúde se unem para oferecer aos associados um benefício especial: mais cuidado com a saúde e tranquilidade para o dia a dia.',
      '📲 Conheça as opções e as condições para associados da AEAGO: América Corretora: (62) 3926-0976',
      'Valorizar a Agronomia também é cuidar de quem faz parte dela!',
      'Parabéns pelo Dia do Engenheiro Agrônomo!',
    ],
    anexos: [
      {
        titulo: 'Conheça a Novamed Planos de Saúde',
        arquivo: 'https://www.novamedplanosdesaude.com.br/',
      },
    ],
  },
  {
    id: 'aeago-lanca-revisao-tabela-honorarios-2026',
    titulo: 'AEAGO lança revisão da Tabela de Honorários Profissionais',
    subtitulo:
      'Revisão contempla aviação agrícola, drones e agricultura de precisão, hidroponia e fertirrigação, e traz destaque para propriedade intelectual e inovação.',
    categoria: 'Institucional',
    data: '24 de setembro de 2026',
    imagem: '/imagem/noticias/Nova_tabela.png',
    corpo: [
      'A AEAGO lança hoje a revisão da Tabela de Honorários Profissionais da Engenharia Agronômica.',
      'A profissão se transforma, e seus referenciais precisam acompanhar essa evolução. Além de contemplar atividades como aviação agrícola, drones e agricultura de precisão, hidroponia e fertirrigação, a revisão traz um destaque para propriedade intelectual e inovação.',
      'Incluir essas áreas é reconhecer que o trabalho do engenheiro agrônomo também gera conhecimento, desenvolve tecnologias e cria soluções para o agro brasileiro. Esse trabalho tem valor e merece ser considerado na formação dos honorários. Confira em nosso site.',
      'Uma tabela mais conectada à Agronomia que praticamos hoje e à inovação que queremos construir no Brasil. 🇧🇷🌱',
      'A nova tabela também pode ser baixada na página inicial do site, na seção Sobre.',
    ],
    anexos: [
      {
        titulo: 'Baixar Tabela de Honorários AEAGO (revisão 2026)',
        arquivo: '/documentos/Tabela de Honorários AEAGO Revisada 032026.pdf',
      },
    ],
  },
  {
    id: 'revista-inova-agro-lancamento-outubro-2026',
    titulo: 'A Revista Inova Agro está chegando',
    subtitulo:
      'Primeira edição da Revista Inova Agro, com lançamento previsto para outubro, terá como dossiê temático o I Congresso de Agronomia na AgroCapital e conta com o patrocínio do Confea.',
    categoria: 'Institucional',
    data: '14 de setembro de 2026',
    imagem: '/imagem/noticias/revista_inova.jpeg',
    corpo: [
      '📖📒 A Revista Inova Agro está chegando!',
      'Com lançamento previsto para outubro, a primeira edição da Revista Inova Agro – Revista Técnico-Científica de Engenharia, Agronomia, Geociências e Inovação reunirá ciência, conhecimento técnico e novas perspectivas para o agronegócio.',
      'O Volume 1, Número 1, 2026, terá como dossiê temático:',
      '"Inova Agro – I Congresso de Agronomia na AgroCapital: Inovação, Tecnologia e Desenvolvimento Sustentável no Agronegócio".',
      'A publicação registrará o legado técnico, científico e institucional do evento realizado entre os dias 2 e 4 de junho de 2026, em Goiânia.',
      'A edição inaugural conta com o patrocínio do Conselho Federal de Engenharia e Agronomia – Confea, fortalecendo a valorização profissional, a produção científica e a divulgação de conhecimentos estratégicos para o desenvolvimento sustentável do agro brasileiro.',
      '📅 Lançamento: outubro de 2026',
    ],
  },
  {
    id: 'aeago-selecionada-edital-patrocinio-confea-revista-inova-agro',
    titulo: 'AEAGO é selecionada no Edital de Patrocínio do Confea com a Revista Inova Agro',
    subtitulo:
      'AEAGO é selecionada no Edital de Patrocínio nº 3/2026 do Confea com a Revista Inova Agro, cuja primeira edição será dedicada ao I Congresso de Agronomia na AgroCapital.',
    categoria: 'Institucional',
    data: '12 de setembro de 2026',
    imagem: '/imagem/noticias/edital_patrocinio.jpeg',
    corpo: [
      'A Associação dos Engenheiros Agrônomos de Goiás – AEAGO foi selecionada no Edital de Patrocínio nº 3/2026 – Parceria com Entidades do Confea, na categoria PUBLICAÇÃO, com a Revista Inova Agro – Revista Técnico-Científica de Engenharia, Agronomia, Geociências e Inovação.',
      '📚 Sua primeira edição, Volume 1, Número 1 – 2026, será publicada como Dossiê Temático: Inova Agro – I Congresso de Agronomia na AgroCapital, reunindo conteúdos produzidos pelos autores dos trabalhos científicos selecionados e pelos palestrantes convidados do congresso.',
      'A publicação nasce com o propósito de promover a integração entre pesquisa, experiência profissional e inovação tecnológica, ampliando a circulação do conhecimento produzido por pesquisadores, profissionais e instituições e aproximando ciência e prática.',
      'O apoio do Confea representa um passo importante para consolidar a Revista Inova Agro como espaço de difusão técnico-científica, valorização profissional e inovação.',
      '🌱 Do Congresso para a Revista. Da pesquisa para o setor. Do conhecimento para a sociedade. Parabéns a todos!',
    ],
  },
  {
    id: 'aeago-define-posicao-institucional-cba-2027',
    titulo: 'AEAGO define posição institucional para o CBA 2027',
    subtitulo:
      'Diretoria aprova três propostas institucionais para as tratativas do Termo de Cooperação com a CONFAEAB, visando à realização do XXXV Congresso Brasileiro de Agronomia.',
    categoria: 'Institucional',
    data: '28 de agosto de 2026',
    imagem: '/imagem/noticias/reuniao-diretoria-CBA.jpeg',
    corpo: [
      'A Diretoria da Associação dos Engenheiros Agrônomos de Goiás reuniu-se, nesta quinta-feira, 27 de agosto, para analisar as condições propostas para o Termo de Cooperação com a CONFAEAB, visando à realização do XXXV Congresso Brasileiro de Agronomia – CBA 2027.',
      'Após amplo diálogo, a Diretoria aprovou três propostas que orientarão a posição institucional da AEAGO nas próximas tratativas:',
      '✅ Retorno ao modelo contratual adotado no XXXIV CBA, com as adaptações necessárias à nova edição;',
      '✅ Nacionalização das indicações para a composição do CONCBA, assegurando representatividade em âmbito nacional;',
      '✅ Instalação imediata do CONCBA, para garantir o início efetivo do planejamento, da organização e do acompanhamento do Congresso.',
      'A AEAGO reconhece a relevância do CBA 2027 e reafirma sua disposição para contribuir com a realização de um Congresso construído com transparência, equilíbrio, participação nacional e governança compartilhada, preservando os interesses institucionais das entidades envolvidas e fortalecendo a Agronomia brasileira.',
    ],
    anexos: [
      {
        titulo: 'Ata da reunião de Diretoria – 27/08/2026',
        arquivo: '/documentos/Ata_AEAGO_27-08-2026_.pdf',
      },
    ],
  },
  {
    id: 'queimadas-em-goias-alerta-aeago',
    titulo: 'Queimadas em Goiás: um alerta que vai além dos prejuízos imediatos',
    subtitulo:
      'Presidente da AEAGO e do Fórum Brasil Central, Fernando Barnabé, alerta para os R$ 710 milhões em prejuízos e até 20 anos de recuperação das áreas atingidas pelo fogo em Goiás.',
    categoria: 'Institucional',
    data: '23 de agosto de 2026',
    imagem: '/imagem/noticias/queimadas.jpeg',
    corpo: [
      'O presidente do Fórum Brasil Central e da AEAGO, Eng. Agr. Fernando Barnabé, concedeu entrevistas à imprensa para tratar de um tema urgente: os impactos das queimadas sobre o campo, o meio ambiente e a economia goiana.',
      'Com prejuízos que já chegam a R$ 710 milhões e áreas que podem demandar até 20 anos para sua recuperação, Fernando destacou a importância da prevenção, do planejamento e da atuação conjunta para reduzir os danos provocados pelo fogo.',
      '🌱 Dar visibilidade a esse debate também é uma forma de mobilizar produtores, profissionais, instituições e poder público para a proteção do Cerrado e da capacidade produtiva do campo.',
      'O Fórum Brasil Central e a AEAGO seguem contribuindo tecnicamente para discussões que impactam diretamente o presente e o futuro do agro.',
    ],
    anexos: [
      {
        titulo: 'Jornal Opção: Queimadas já causaram prejuízo milionário ao campo goiano',
        arquivo: 'https://www.jornalopcao.com.br/agronegocio/queimadas-ja-causaram-prejuizo-milionario-ao-campo-goiano-aeago-alerta-para-riscos-859192/',
      },
      {
        titulo: 'Jornal Opção: Reflorestamento após incêndios pode levar até 20 anos',
        arquivo: 'https://www.jornalopcao.com.br/cidades/reflorestamento-apos-incendios-pode-levar-ate-20-anos-e-custo-e-do-produtor-diz-presidente-da-associacao-dos-engenheiros-agronomos-859632/',
      },
      {
        titulo: 'Portal Cerrado Notícias: Queimadas já causaram prejuízo de R$ 710 milhões em Goiás',
        arquivo: 'https://portalcerradonoticias.com.br/queimadas-ja-causaram-prejuizo-de-r-710-milhoes-em-goias/',
      },
    ],
  },
  {
    id: 'do-campo-ao-mercado-patentes-inovacao-transferencia-tecnologia',
    titulo: 'Do Campo ao Mercado: patentes, inovação e transferência de tecnologia na Agronomia',
    subtitulo:
      'Novo curso mostra como o Engenheiro Agrônomo pode proteger, licenciar e transformar inovações do campo em negócio e impacto para o Agro.',
    categoria: 'Institucional',
    data: '15 de agosto de 2026',
    imagem: '/imagem/curso/do-campo-ao-mercado.jpeg',
    corpo: [
      '🌱 Engenheiro Agrônomo, você sabe reconhecer quando uma ideia pode virar uma patente?',
      'A Agronomia está muito além da produção no campo. Hoje, o profissional também participa do desenvolvimento de novas tecnologias, processos, equipamentos, bioinsumos, soluções ambientais, sistemas de produção e inovações para o Agro.',
      'Mas criar uma boa solução é apenas o começo.',
      '💡 Como proteger uma inovação?',
      '🔎 Como saber se uma tecnologia pode ser patenteada?',
      '📄 O que é preciso fazer antes de divulgar uma ideia?',
      '🤝 Como funciona a transferência de tecnologia?',
      '💰 É possível licenciar uma tecnologia e gerar royalties?',
      '🚀 Como levar uma solução técnica da pesquisa ou do campo até o mercado?',
      'É justamente esse caminho que vamos apresentar no curso "Do Campo ao Mercado: Patentes, Inovação e Transferência de Tecnologia na Agronomia".',
      'Serão 3 horas de capacitação, com uma abordagem prática e direcionada à realidade profissional do Engenheiro Agrônomo.',
      'Porque o Agrônomo não precisa apenas usar tecnologias.',
      '👉 Ele também pode criar, proteger, transferir e transformar tecnologia em negócio e impacto para o Agro.',
      '🌾 Inovação também é campo de atuação da Agronomia.',
    ],
    anexos: [
      {
        titulo: 'Inscreva-se no curso',
        arquivo: 'https://www.sympla.com.br/evento-online/do-campo-ao-mercado-patentes-inovacao-e-transferencia-de-tecnologia-na-agronomia/3534449',
      },
    ],
  },
  {
    id: 'dra-mariangela-hungria-abertura-cbcs',
    titulo: 'Dra. Mariangela Hungria confirmada para abertura do XL Congresso Brasileiro de Ciência do Solo',
    subtitulo:
      'Pesquisadora da Embrapa Soja e vencedora do World Food Prize 2025 fará a palestra magna sobre o papel da ciência do solo na construção de uma agricultura regenerativa.',
    categoria: 'Institucional',
    data: '1 de agosto de 2026',
    imagem: '/imagem/noticias/CBCS-MARIANGELA.jpeg',
    corpo: [
      '🌟 Palestra de abertura confirmada! 🌟',
      'É com imensa honra que anunciamos a palestrante que abrirá o XL Congresso Brasileiro de Ciência do Solo!',
      'A Dra. Mariangela Hungria, pesquisadora da Embrapa Soja e laureada com o prestigiado World Food Prize 2025, considerado o "Nobel da Agricultura", será a responsável por inaugurar as atividades científicas do maior evento de ciência do solo do Brasil.',
      'Sua palestra magna, intitulada "Da revolução verde à revolução biológica: o papel da ciência do solo na construção de uma agricultura regenerativa", promete traçar um panorama histórico e visionário sobre como a microbiologia do solo pode transformar a agricultura tropical, garantindo produtividade com sustentabilidade ambiental.',
      'A Dra. Mariangela é referência mundial em fixação biológica de nitrogênio e desenvolvimento de inoculantes microbianos. Suas pesquisas já economizaram bilhões de dólares para a agricultura brasileira e reduziram significativamente as emissões de gases de efeito estufa no campo.',
      'Não perca este momento histórico!',
      '📅 01 de agosto de 2027 (domingo)',
      '⏰ 20h — logo após a Cerimônia de Abertura',
      '📍 Caldas Novas – GO',
    ],
  },
  {
    id: 'nota-repudio-organizacao-xxxv-cba',
    titulo: 'AEAGO reafirma seu compromisso com a transparência, a democracia e a valorização da Agronomia',
    subtitulo:
      'AEAGO manifesta seu repúdio à condução unilateral da organização do XXXV Congresso Brasileiro de Agronomia – CBA.',
    categoria: 'Nota Oficial',
    data: '24 de julho de 2026',
    imagem: '/imagem/NOTA OFICIAL.png',
    corpo: [
      'A Associação dos Engenheiros Agrônomos de Goiás (AEAGO) informa aos seus associados que encaminhou à Confederação dos Engenheiros Agrônomos do Brasil (CONFAEAB) o Ofício de Repúdio e Notificação Institucional nº 39/2026 – AEAGO, de 24 de julho de 2026, manifestando profunda preocupação com a forma como vêm sendo conduzidos os atos preparatórios do XXXV Congresso Brasileiro de Agronomia (CBA).',
      'A AEAGO foi escolhida por unanimidade, durante a Assembleia Geral realizada em Maceió/AL, para sediar o XXXV Congresso Brasileiro de Agronomia, decisão democrática que conferiu à nossa entidade a responsabilidade de atuar como anfitriã e parceira na organização do evento. Entretanto, a Diretoria da AEAGO constatou que diversas decisões estratégicas relativas ao Congresso foram deliberadas pela Diretoria da CONFAEAB sem que a entidade anfitriã fosse convocada para participar dessas deliberações, incluindo temas como data do evento, tema oficial, identidade visual, eixos temáticos, diretrizes para inscrições e outros atos relevantes da organização.',
      'Também causa preocupação o fato de que somente após essas deliberações a AEAGO tenha sido convocada para uma reunião de "alinhamento estratégico" e para a formalização do Termo de Parceria, situação que, no entendimento da Associação, não se compatibiliza com os princípios da gestão compartilhada, da transparência e da construção conjunta previstos no próprio Estatuto da CONFAEAB e no modelo de governança estabelecido para o Congresso.',
      'Diante desse cenário, a AEAGO adotou as medidas institucionais cabíveis, requerendo, entre outros pontos: a efetiva instalação da Comissão Organizadora Nacional com participação plena da AEAGO; a suspensão de novas deliberações unilaterais sobre o Congresso; o acesso à documentação produzida até o momento; a apreciação colegiada dos atos já praticados relacionados à organização do evento.',
      'A AEAGO ressalta que não é contrária à realização do XXXV Congresso Brasileiro de Agronomia. Ao contrário, continuará trabalhando para que Goiás sedie um Congresso histórico, representativo e à altura da Engenharia Agronômica brasileira.',
      'Nosso compromisso é assegurar que a organização do evento ocorra com respeito às decisões democráticas da Assembleia Geral, à autonomia das entidades filiadas, à boa-fé institucional e à governança compartilhada, garantindo que a AEAGO exerça, de forma plena, o papel que lhe foi legitimamente confiado.',
      'Em respeito aos princípios da transparência institucional e para conhecimento dos associados, a AEAGO disponibiliza a íntegra do documento encaminhado à CONFAEAB.',
    ],
    anexos: [
      {
        titulo: 'Documento Oficial: Ofício nº 39/2026 – AEAGO',
        arquivo: '/documentos/OFICIO_DE_REPUDIO.pdf',
      },
    ],
  },
  {
    id: 'aeago-fortalece-protagonismo-na-cbh-paranaiba',
    titulo: 'AEAGO fortalece protagonismo na gestão das águas e passa a integrar instância estratégica do CBH Paranaíba',
    subtitulo: 'Associação dos Engenheiros Agrônomos de Goiás passa a integrar o Grupo de Acompanhamento do Contrato de Gestão (GACG) do CBH Paranaíba, reforçando seu protagonismo na governança dos recursos hídricos e no desenvolvimento sustentável.',
    categoria: 'Institucional',
    data: '24 de julho de 2026',
    imagem: '/imagem/noticias/aeago-cbh-paranaiba.jpeg',
    imagens: [
      '/imagem/noticias/aeago-cbh-paranaiba01.jpeg',
      '/imagem/noticias/aeago-cbh-paranaiba02.jpeg',
      '/imagem/noticias/aeago-cbh-paranaiba03.jpeg',
      '/imagem/noticias/aeago-cbh-paranaiba04.jpeg',
      '/imagem/noticias/aeago-cbh-paranaiba05.jpeg',
    ],
    corpo: [
      'A Associação dos Engenheiros Agrônomos de Goiás (AEAGO) ampliou sua atuação institucional ao tomar posse como membro do Comitê da Bacia Hidrográfica do Rio Paranaíba (CBH Paranaíba) durante a Assembleia de Posse da gestão 2026–2030 e a 38ª Reunião Extraordinária, realizada em Itumbiara (GO).',
      'A entidade também passou a integrar, como titular, o Grupo de Acompanhamento do Contrato de Gestão (GACG), uma das principais instâncias de governança do colegiado.',
      'Representando a AEAGO, o presidente Fernando Barnabé participou da cerimônia de posse ao lado dos engenheiros agrônomos Robledo Soyer, Antônio Pasqualetto e Thiago Castro, reforçando o compromisso da associação com a gestão participativa dos recursos hídricos, a sustentabilidade e o fortalecimento das políticas públicas voltadas ao desenvolvimento do agronegócio.',
      'A AEAGO segue ampliando sua presença nos espaços de decisão que impactam diretamente a Agronomia e o agronegócio goiano, contribuindo para uma gestão responsável, técnica e sustentável dos recursos naturais.',
      '💧 AEAGO – Presente onde as decisões importam.',
    ],
  },
  {
    id: 'publicacao-oficial-dos-anais-do-inova-agro',
    titulo: 'Publicação Oficial dos Anais do Inova Agro',
    subtitulo: 'Os Anais do I Congresso de Agronomia na Agrocapital eternizam a produção científica de um dos mais relevantes encontros do agronegócio brasileiro.',
    categoria: 'Institucional',
    data: '19 de julho de 2026',
    imagem: '/imagem/noticias/publicacao-anais-inova-agro02.jpeg',
    corpo: [
      '📚 Publicação Oficial dos Anais do Inova Agro',
      'É com grande satisfação que celebramos a publicação oficial dos Anais do I Congresso de Agronomia na Agrocapital, uma obra que eterniza a produção científica apresentada durante um dos mais relevantes encontros do agronegócio brasileiro.',
      'Agradecemos à Agrocapital, por viabilizar a realização do congresso científico em sua programação; à Mútua, pelo patrocínio e apoio; aos reitores e dirigentes das instituições parceiras; aos autores, ao Comitê Científico, e a todos os professores, pesquisadores, estudantes, patrocinadores, apoiadores e colaboradores que contribuíram para o sucesso desta iniciativa.',
      'Nosso agradecimento ao Editor-Chefe, Prof. Dr. Bernardo Cunha Senra Barros, e à Editora da Revista Produções Técnicas da Univassouras, Profa. Paloma Martins, pela excelência editorial na publicação desta obra.',
      'Com mais de 2 mil participantes, mais de 30 palestrantes, 62 trabalhos científicos e um Comitê Científico formado por mais de 50 pesquisadores, o Inova Agro consolidou-se como um espaço de integração entre academia, setor produtivo e entidades de classe, fortalecendo a inovação, a pesquisa e o desenvolvimento sustentável da Agronomia e do agro brasileiro.',
      'Parabéns a todos que fizeram parte desta história! 🌱📚',
    ],
    anexos: [
      {
        titulo: 'Acessar publicação na editora',
        arquivo: 'https://editora.univassouras.edu.br/index.php/PT/issue/view/465',
      },
      {
        titulo: 'Baixar e-book do Inova Agro',
        arquivo: '/documentos/ebook-InovaAgro.pdf',
      },
    ],
  },
  {
    id: 'thais-eloila-contemplada-sorteio-soea-2026',
    titulo: 'Thais Heloila é contemplada no sorteio da vaga para a SOEA 2026',
    subtitulo: 'Após atender a todos os pré-requisitos do regulamento, a associada garantiu sua vaga na 81ª Semana Oficial da Engenharia e da Agronomia.',
    categoria: 'Institucional',
    data: '10 de julho de 2026',
    imagem: '/imagem/noticias/thais-eloila-sorteio-soea-2026.jpeg',
    corpo: [
      'É com muita alegria que anunciamos que a associada Thais Heloila foi a contemplada no sorteio da vaga para participação na 81ª Semana Oficial da Engenharia e da Agronomia (SOEA 2026)! 🌱',
      'Após a conferência, foi verificado que a associada atendeu a todos os pré-requisitos previstos no regulamento, incluindo:',
      '✅ Ser associada à AEAGO;',
      '✅ Estar com a anuidade 2026 em dia;',
      '✅ Possuir registro ativo no CREA;',
      '✅ Confirmar a disponibilidade para participação no evento.',
      'Parabenizamos a Thais Heloila pela conquista e agradecemos a todos os associados que participaram do sorteio e fortalecem diariamente a AEAGO.',
    ],
  },
  {
    id: 'aeago-interior',
    titulo: 'AEAGO pelo interior: presença que se faz na estrada!',
    subtitulo: 'Mais de 2 mil quilômetros de estrada. Uma AEAGO cada vez mais próxima do interior.',
    categoria: 'Institucional',
    data: '7 de julho de 2026',
    imagem: '/imagem/noticias/aeago-interior.jpeg',
    corpo: [
      '🌱🚙 AEAGO pelo interior: presença que se faz na estrada!',
      'O presidente da AEAGO, Eng. Agr. Fernando Barnabé, percorreu nas últimas semanas mais de 2.000 km pelas estradas de Goiás, passando por diferentes regiões do estado, visitando municípios, ouvindo profissionais e fortalecendo a presença da Associação junto a quem faz a Agronomia acontecer todos os dias. 🌾🤝',
      'Do Norte ao Sudoeste, do Sul ao Oeste goiano, cada quilômetro representa proximidade, diálogo, valorização profissional e compromisso com os engenheiros agrônomos de Goiás.',
      '🛣️ Mais de 2 mil quilômetros de estrada. Uma AEAGO cada vez mais próxima do interior.',
      'Presente em todas as regiões, junto com quem faz a Agronomia acontecer.',
    ],
  },
  {
    id: 'colheita-milho',
    titulo: 'AEAGO participa da Abertura Estadual da Colheita de Milho – 2ª Safra 2026 e reforça compromisso com o agronegócio goiano',
    subtitulo: 'Presidente Fernando Barnabé representou a entidade ao lado da Aprosoja Goiás, fortalecendo a integração institucional e o apoio ao desenvolvimento sustentável, à inovação e à valorização da Engenharia Agronômica.',
    categoria: 'Institucional',
    data: '26 de junho de 2026',
    imagem: '/imagem/noticias/colheita-milho01.jpeg',
    imagens: [
      '/imagem/noticias/colheita-milho01.jpeg',
      '/imagem/noticias/colheita-milho02.jpeg',
      '/imagem/noticias/colheita-milho03.jpeg',
      '/imagem/noticias/colheita-milho04.jpeg',
      '/imagem/noticias/colheita-milho05.jpeg',
    ],
    corpo: [
      'A Associação dos Engenheiros Agrônomos de Goiás (AEAGO) marcou presença na Abertura Estadual da Colheita de Milho – 2ª Safra 2026, um dos principais eventos do agronegócio goiano.',
      'Representando a entidade, o presidente da AEAGO, Engenheiro Agrônomo, Fernando Barnabé, participou da solenidade ao lado do presidente da Aprosoja Goiás, Clodoaldo Calegari, reforçando a integração entre as entidades e o compromisso conjunto com o fortalecimento da agricultura, da inovação e da valorização dos engenheiros agrônomos.',
      'A AEAGO segue atuando de forma ativa nos principais fóruns e eventos do setor, contribuindo para o desenvolvimento sustentável e o avanço do agronegócio em Goiás.',
      '🌽 AEAGO – Ao lado de quem faz o agro acontecer.',
    ],
  },
  {
    id: 'novo-telefone-contato',
    titulo: 'Novo número de telefone',
    subtitulo: 'Anote aí!',
    categoria: 'Notícia',
    data: '30 de março de 2026',
    imagem: '/imagem/noticias/novo-numero.jpeg',

    corpo: [
      'Atualize em sua agenda o novo número de contato da AEAGO!',
    ],

  },
  {
    id: 'aeago-no-portal-agro-2',
    titulo: 'AEAGO NO PORTAL AGRO 2',
    subtitulo: 'Plantando ideias. Colhendo soluções.',
    categoria: 'Institucional',
    data: '7 de abril de 2026',
    imagem: '/imagem/noticias/portal-agro-2.png',

    corpo: [
      'Quem vive no campo sabe que nem sempre dá pra esperar: é decisão rápida, problema para resolver e a produção não pode parar.',
      'Nesse cenário, a agronomia desempenha papel fundamental ao produtor rural, oferecendo orientação, suporte e apoio nas melhores escolhas para a produtividade.',
      'O presidente Fernando Barnabé explica, nesta entrevista, a importância das entidades do agro nesse processo.'
    ],

    anexos: [
      {
        titulo: 'Canal Agro 2',
        arquivo: 'https://www.youtube.com/watch?v=C60prMGE1Z0',
      },
    ],
  },

  {
    id: 'resultado-do-sorteio-aeago-2026',
    titulo: 'RESULTADO DO SORTEIO AEAGO 2026',
    categoria: 'Institucional',
    data: '31 de março de 2026',
    imagem: '/imagem/noticias/resultado-sorteio-aeago-2026.png',

    corpo: [
      'Parabéns aos contemplados no sorteio AEAGO 2026:',
      'Curso Chief Climate Officer: Leonardo Veloso do Prado (36).',
      'Pós-graduação IA no Agro: Rubens Fernandes Faria (88).',
      'Pós-graduação Mercado e Operações no Agro EAD: Kamila Almeida de Ataíde (112).',
      'Curso Consultoria em Agronegócios: Fernanda Simão Souza (185).',
      'Os números correspondem à ordem de associação em 2026.',
      'O presidente Fernando Barnabé entrará em contato com os contemplados para orientar os próximos passos junto à Universidade de Vassouras.',
      'Parabéns! Seguimos fortalecendo a agronomia.'
    ],

    anexos: [
      {
        titulo: 'Post do sorteio',
        arquivo: 'https://www.instagram.com/p/DWkZZcqCd6A/?img_index=1',
      },
    ],
  },

  {
    id: 'o-agro-do-brasil-central-na-tv',
    titulo: 'O Agro do Brasil Central na TV',
    subtitulo: 'O agronegócio ganha ainda mais força e representatividade na TV Serra Dourada | SBT.',
    categoria: 'Institucional',
    data: '30 de março de 2026',
    imagem: '/imagem/noticias/o-agro-do-brasil-central-na-tv.png',

    corpo: [
      'O presidente Fernando Barnabé participou do programa Agronegócio representando o Fórum Brasil Central de Agronomia.',
      'A participação reforça o compromisso institucional com o fortalecimento do setor no Brasil Central.',
      'O espaço valoriza a voz das entidades e amplia o alcance da agronomia no país.',
      'O Fórum segue promovendo integração, representatividade e desenvolvimento para o agro brasileiro.'
    ],

    anexos: [
      {
        titulo: 'Assistir no YouTube',
        arquivo: 'https://youtu.be/f5u5KtDT8Gs?si=t36vGBTQ2KCjIRSH',
      },
    ],
  },

  {
    id: 'conexao-safra',
    titulo: 'Inova Agro estreia como primeiro congresso acadêmico dentro da AgroCapital',
    subtitulo: 'Evento será realizado entre os dias 2 e 4 de junho, em Goiânia, reunindo pesquisadores, profissionais, estudantes, produtores e lideranças do setor dentro da maior feira do agronegócio do Centro-Oeste',
    categoria: 'Institucional',
    data: '14 de maio de 2026',
    imagem: '/imagem/noticias/conexao-safra.jpeg',

    corpo: [
      'A cidade de Goiânia receberá, entre os dias 2 e 4 de junho de 2026, o Inova Agro – 1º Congresso de Agronomia na AgroCapital, iniciativa inédita que promete marcar uma nova fase nas feiras do agronegócio brasileiro ao integrar, pela primeira vez, uma programação acadêmica e científica estruturada dentro da tradicional Feira AgroCapital.',
      'O congresso acontecerá paralelamente à feira, realizada de 1º a 5 de junho, considerada uma das maiores vitrines do agronegócio da região Centro-Oeste.'
    ],

    anexos: [
      {
        titulo: 'Conexão Safra',
        arquivo: 'https://conexaosafra.com/eventos/inova-agro-estreia-como-primeiro-congresso-academico-dentro-da-agrocapital/',
      },
      {
        titulo: 'Notícia Todo Dia',
        arquivo: 'https://www.ntdbr.com.br/component/k2/item/4028-inova-agro-estreia-dentro-da-agrocapital-e-amplia-debate-tecnico-no-agronegocio-brasileiro?fbclid=-PvYKO1PYnxbGR6nbntV2wazrRmj1-5l8osPyNHptcVoHNwg_aem_EZ7TPIPfg23toG7deoR1Sw',
      },
    ]
  },
  {
    id: 'agro-uruacu',
    titulo: 'Presidente da AEAGO fortalece diálogo com lideranças do agronegócio em Uruaçu',
    subtitulo: 'Fortalecimento e Parceria Regional',
    categoria: 'Institucional',
    data: '23 de junho de 2026',
    imagem: '/imagem/noticias/uruacu02.jpeg',

    corpo: [
      'No dia 23 de junho, o presidente da Associação dos Engenheiros Agrônomos de Goiás (AEAGO), Eng. Agr. Fernando Barnabé, esteve em Uruaçu em uma importante agenda de aproximação com os profissionais e lideranças do agronegócio do Norte Goiano.',
      'Durante a visita, reuniu-se com Cristovam de Ávila Júnior, Engenheiro Agrônomo e Presidente da AGROAPIU, Fainy Rodrigues, Presidente da APROAGRU, e Antônio José de Araújo, Diretor da APROSOJA, fortalecendo o diálogo institucional e debatendo temas estratégicos para o desenvolvimento da Agronomia e do agronegócio na região.',
      'A iniciativa reforça o compromisso da AEAGO com a valorização dos engenheiros agrônomos, a representatividade da categoria e a construção de parcerias que contribuam para o crescimento sustentável do setor produtivo goiano.',
      'A AEAGO segue presente em todo o estado, ouvindo os profissionais, fortalecendo conexões e trabalhando pelo fortalecimento da Agronomia.',
      'Agradecemos a todos os engenheiros agrônomos e lideranças da região que participaram desse momento de integração e fortalecimento institucional.'
    ],
  },
];

export default function NoticiaDetalhe() {
  const { id } = useParams();
  const noticia = NOTICIAS.find((n) => n.id === id);
  const [imagemAtual, setImagemAtual] = useState(0);

  useEffect(() => {
    setImagemAtual(0);
  }, [id]);

  if (!noticia) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-2xl font-bold text-navy">Notícia não encontrada</h1>

        <Link to="/#noticias" className="mt-4 inline-block text-navy underline">
          Voltar para notícias
        </Link>
      </div>
    );
  }

  const temCarrossel = Array.isArray(noticia.imagens) && noticia.imagens.length > 0;
  const temImagem = Boolean(noticia.imagem);
  const temAnexos = Array.isArray(noticia.anexos) && noticia.anexos.length > 0;
  const temSubtitulo = Boolean(noticia.subtitulo);
  const temCategoria = Boolean(noticia.categoria);

  return (
    <article className="max-w-3xl mx-auto px-6 pt-28 pb-12 text-center">
      {/* TÍTULO */}
      <h1 className="text-3xl md:text-4xl font-bold text-navy leading-tight mb-3">
        {noticia.titulo}
      </h1>

      {/* SUBTÍTULO */}
      {temSubtitulo && (
        <p className="text-lg text-gray-600 leading-relaxed mb-4">
          {noticia.subtitulo}
        </p>
      )}

      {/* DATA + CATEGORIA */}
      <div className="text-sm text-gray-500 mb-8">
        <span>{noticia.data}</span>
        {temCategoria && <span> • {noticia.categoria}</span>}
      </div>

      {/* CARROSSEL DE IMAGENS */}
      {temCarrossel ? (
        <div className="mb-8 relative">
          <div className="overflow-hidden rounded-xl shadow-md">
            <img
              src={process.env.PUBLIC_URL + noticia.imagens[imagemAtual]}
              alt={`${noticia.titulo} – foto ${imagemAtual + 1}`}
              className="w-full max-h-[840px] object-cover"
            />
          </div>
          {noticia.imagens.length > 1 && (
            <>
              <button
                onClick={() => setImagemAtual((prev) => (prev - 1 + noticia.imagens.length) % noticia.imagens.length)}
                className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full px-3 py-2 text-navy font-bold shadow"
                aria-label="Imagem anterior"
              >
                ←
              </button>
              <button
                onClick={() => setImagemAtual((prev) => (prev + 1) % noticia.imagens.length)}
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full px-3 py-2 text-navy font-bold shadow"
                aria-label="Próxima imagem"
              >
                →
              </button>
              <div className="flex justify-center gap-2 mt-3">
                {noticia.imagens.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setImagemAtual(idx)}
                    className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === imagemAtual ? 'bg-navy' : 'bg-gray-300'}`}
                    aria-label={`Ir para foto ${idx + 1}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      ) : temImagem && (
        <div className="mb-8">
          <img
            src={process.env.PUBLIC_URL + noticia.imagem}
            alt={noticia.titulo}
            className="w-full h-auto rounded-xl shadow-md"
          />
        </div>
      )}

      {/* CORPO DA NOTÍCIA */}
      <div
        className={`text-gray-700 leading-relaxed text-[17px] space-y-6 ${temImagem ? 'mt-0' : 'mt-2'
          }`}
      >
        {noticia.corpo?.map((paragrafo, idx) => (
          <p key={idx}>{paragrafo}</p>
        ))}
      </div>

      {/* ANEXOS / DOCUMENTOS (OPCIONAL) */}
      {temAnexos && (
        <div className="mt-10 border-t border-gray-200 pt-6">
          <h2 className="text-lg font-semibold text-navy mb-3">Documentos</h2>

          <div className="space-y-2">
            {noticia.anexos.map((doc, i) => (
              <a
                key={i}
                href={doc.arquivo.startsWith('/') ? process.env.PUBLIC_URL + encodeURI(doc.arquivo) : doc.arquivo}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-navy hover:underline font-medium"
              >
                📄 {doc.titulo}
              </a>
            ))}
          </div>
        </div>
      )}

      {/* BOTÃO VOLTAR */}
      <div className="mt-12">
        <Link
          to="/#noticias"
          className="inline-flex items-center text-navy hover:underline font-medium"
        >
          ← Voltar para notícias
        </Link>
      </div>
    </article>
  );
}
